// generated by the plop

import { PreparationForUse, RegistrationPreparationForUseModel } from '../../symbols';

export class RegistrationPreparationForUse {
  static type = '[preparingForUse] RegistrationPreparationForUse';

  constructor(public data: RegistrationPreparationForUseModel) {
  }
}

export class RegistrationPreparationForUseSuccess {
  static type = '[preparingForUse] RegistrationPreparationForUseSuccess';

  constructor(public data: PreparationForUse) {
  }
}
